<template>
  <div>
    <div class="detail">
      <!-- 当前发票信息概况： -->
      <h6>{{ $t("message.summaryOfCurrentInvoiceInformation") }}：</h6>
      <!-- 列表信息-->
      <div class="information">
        <div class="row">
          <!--当前日期  -->
          <div class="item">
            <div class="label">{{ $t("message.currentDate") }}</div>
            <div class="value border-right">{{ base.date }}</div>
          </div>
          <!-- 发票状态 -->
          <div class="item">
            <div class="label">{{ $t("message.invoiceStatus") }}</div>
            <div class="value">{{ base.status_name }}</div>
          </div>
        </div>
        <div class="row">
          <!--发送方式  -->
          <div class="item">
            <div class="label">{{ $t("message.wayToSend") }}</div>
            <div class="value border-right">
              {{ logistics(base.logistics_id) }}
            </div>
          </div>
          <!-- 计抛比例 -->
          <div class="item">
            <div class="label">{{ $t("message.meterThrowRatio") }}</div>
            <div class="value">{{ base.volumeWeightRate }}</div>
          </div>
        </div>
        <div class="row">
          <!--物流单号  -->
          <div class="item">
            <div class="label">{{ $t("message.logisticsSingleNumber") }}</div>
            <div class="value border-right">
              {{ base.express_no }}
            </div>
          </div>
          <!-- 合计体积 -->
          <div class="item">
            <div class="label">{{ $t("message.totalVolume") }}</div>
            <div class="value">{{ total.volume }}</div>
          </div>
        </div>
        <div class="row">
          <!--箱数  -->
          <div class="item">
            <div class="label">{{ $t("message.boxNum") }}</div>
            <div class="value border-right">{{ base.total_box_count }}</div>
          </div>
          <div class="item">
            <div class="label"></div>
            <div class="value"></div>
          </div>
        </div>
      </div>
      <!-- 箱子详情 -->
      <div class="boxDetail">
        <div class="list" v-for="(item, index) in detail" :key="index">
          <div class="item">
            <!-- 配送单号 -->
            <div class="porder">
              {{ item.porder_sn }}
              <span class="boxNum">箱数:
                <span style="color: #2c96e7">{{ item.list.length }}</span>
              </span>
            </div>
            <!-- 箱子列表 -->
            <div class="table">
              <ol>
                <!-- 配送单箱号 -->
                <li>{{ $t("message.deliveryListNumber") }}</li>
                <!-- 重量(kg) -->
                <li>{{ $t("message.weight") }}(kg)</li>
                <!-- 长-->
                <li>{{ $t("message.length") }}(cm)</li>
                <!-- 宽-->
                <li>{{ $t("message.width") }}(cm)</li>
                <!-- 高-->
                <li>{{ $t("message.height") }}(cm)</li>
                <!-- 体积 -->
                <li>{{ $t("message.volume") }}(m³)</li>
                <!-- 抛重 -->
                <li>{{ $t("message.throwWeight") }}(kg)</li>
                <!-- 计费重量-->
                <li>{{ $t("message.BillingWeight") }}</li>
              </ol>
              <ul v-for="(box, boxIndex) in item.list" :key="boxIndex">
                <!-- 配送单箱号 -->
                <li>{{ box.number }}</li>
                <!-- 重量(kg) -->
                <li>{{ box.weight }}(kg)</li>
                <!-- 长-->
                <li>{{ box.length }}(cm)</li>
                <!-- 宽-->
                <li>{{ box.width }}(cm)</li>
                <!-- 高-->
                <li>{{ box.height }}(cm)</li>
                <!-- 体积 -->
                <li>{{ box.volume }}(m³)</li>
                <!-- 抛重 -->
                <li>{{ box.volume_weight }}(kg)</li>
                <!-- 计费重量-->
                <li>{{ box.charge_weight }}(kg)</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="total">
          <ul>
            <!-- 合计 -->
            <li class="text-left">{{ $t("message.total") }}:</li>
            <!-- 重量(kg) -->
            <li>{{ total.weight }}(kg)</li>
            <!-- 长-->
            <li></li>
            <!-- 宽-->
            <li></li>
            <!-- 高-->
            <li></li>
            <!-- 体积 -->
            <li>{{ total.volume }}(m³)</li>
            <!-- 抛重 -->
            <li>{{ total.volume_weight }}(kg)</li>
            <!-- 计费重量-->
            <li>{{ total.charge_weight }}(kg)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    base: { type: Object },
  },
  data() {
    return {
      detail: [],
      total: {
        weight: 0,
        volume: 0,
        volume_weight: 0,
        charge_weight: 0,
      },
    };
  },
  created() {
    this.expressFreightList();
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),
  },
  methods: {
    expressFreightList() {
      let datas = {
        express_no: this.$route.query.express_no,
      };
      this.total = {
        weight: 0,
        volume: 0,
        volume_weight: 0,
        charge_weight: 0,
      };
      this.$api.invoiceApi.expressFreightList(datas).then((res) => {
        this.detail = res.data;
        res.data.forEach((item) => {
          item.list.forEach((items) => {
            this.total.weight += items.weight - 0;
            this.total.volume += items.volume - 0;
            this.total.volume_weight += items.volume_weight - 0;
            this.total.charge_weight += items.charge_weight - 0;
          });
        });
      });
    },
    // 物流方式转换
    logistics(id) {
      let name;
      this.logisticsList.forEach((item) => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },
  },
};
</script>
<style lang='scss' scoped>
.detail {
  .information {
    width: 1000px;
    border: 2px solid #32323c;
    border-radius: 4px;

    .row {
      display: flex;
      border-bottom: 1px solid #32323c;

      &:nth-last-child(1) {
        border: 0;
      }

      .item {
        flex: 1;
        display: flex;
        height: 60px;

        .label {
          flex: 1;
          border-right: 1px solid #32323c;
          color: #333333;
        }

        .value {
          flex: 2.2;
          color: #2c96e7;
        }

        .border-right {
          border-right: 1px solid #32323c;
        }

        div {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
        }
      }
    }
  }

  .boxDetail {
    background: #f8f8f8;
    border-radius: 8px;
    padding: 35px 40px;
    margin-top: 40px;

    .list {
      margin-bottom: 35px;

      .item {
        .porder {
          font-size: 16px;
          margin-bottom: 17px;

          .boxNum {
            margin-left: 97px;
          }
        }

        .table {
          border: 1px solid #edeff4;

          ul {
            padding: 0;

            &:nth-last-child(1) {
              border-bottom: 0;
            }

            li {
              padding: 24px 0;
            }
          }

          li {
            border-right: 1px solid #edeff4;

            &:nth-last-child(1) {
              border-right: 0;
            }
          }
        }
      }
    }
  }

  .total {
    position: sticky;
    left: 0;
    bottom: 0;
    box-shadow: 0px 0px 6px 0px rgba(9, 9, 9, 0.1);
    border-radius: 0px 0px 8px 8px;

    ul {
      display: flex;
      background: #f8f8f8;

      li {
        flex: 1;
        padding: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-left {
        justify-content: start;
      }
    }
  }
}

h6 {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
}
</style>